import { useInfiniteQuery } from "@tanstack/react-query";

import type { paths } from "@/api/types";
import type { Result } from "@/shared/api";
import { apiGetPage, nextCursor, PAGE_LIMIT, qk } from "@/shared/api";
import type { RequestStatus } from "@/entities/deposit";

export type AdminWithdrawal = Result<paths["/api/v1/admin/withdrawals"]["get"]>[number];

export function useWithdrawals(statuses: RequestStatus[]) {
  return useInfiniteQuery({
    queryKey: qk.withdrawals(statuses),
    initialPageParam: undefined as string | undefined,
    queryFn: ({ pageParam, signal }) =>
      apiGetPage("/api/v1/admin/withdrawals", {
        query: {
          limit: PAGE_LIMIT,
          ...(statuses.length ? { status: statuses } : {}),
          ...(pageParam ? { cursor: pageParam } : {}),
        },
        signal,
      }),
    getNextPageParam: (last) => nextCursor(last.meta),
  });
}
